// extracted by mini-css-extract-plugin
module.exports = {"container":"Slot_container__1DpWS","unOccupiedWrapper":"Slot_unOccupiedWrapper__1NptP","plus":"Slot_plus__3k_Nu"};